module.exports = __webpack_public_path__ + "img/syngenta.9126cf13.jpg";